
<script>
  // 2023
  import {viewMode} from './stores/LocalStorage.js';

  //
  import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'
  import 'mapbox-gl/dist/mapbox-gl.css';
  import Login from './Login.svelte';
  import {createEventDispatcher} from 'svelte';
  import {mapStyleDark, mapStyleSatelite, mapStyleStreet} from './definitions/MapStyles.js';
  import PositionLog from './PositionLog.svelte';
  import { onMount } from 'svelte'
  import devices from './stores/DeviceStore.js';
  import userProfiles from './stores/UserProfileStore.js';
  import appSettings from './stores/AppSettingsStore.js';
  import gpsPosition from './stores/DevicePositionStore.js';
  import Modal from './Modal.svelte';
  import mapboxgl from 'mapbox-gl';
  import MapboxDraw from "@mapbox/mapbox-gl-draw";
  mapboxgl.accessToken = 'pk.eyJ1IjoidG9yZWpzIiwiYSI6ImNram1xb3l5bzNubTIydnNjaXU5ZzZsNzQifQ.c00v2ulTBv7eIlsUaK8pdQ'
  export let app;
  let map;
  let keywords = "";
  let showPanel;
  let selectedTab = 'gpstrackers';
  let loadedDeviceMarkers = [];
  let loadedUserProfileMarkers = [];
  let searchInput;
  let drawControlEnabled = false;
  const dateOptions = {year: 'numeric', month: 'long', day: 'numeric', hour: "numeric", minute: "numeric"};
  let modal = {show: false, content: {}};
  const modalEvents = async (e) => {
        if(e.detail.tag == 'close') return modal.show = false;
  }

  // 2023

  const deleteMapFeatureHandler = async (mapFeature) => {
    let text = `Delete geofence ${mapFeature.title}?`;
    if (confirm(text) == true) {

      // Needs update this block so we delete one single layer from the map without a complete reload
      const mapFeatureId = mapFeature._id;
      await clearSearch();
      await reloadMapFeatures();
      unloadGeofenceHandler();

      const body = {mapFeatureId: mapFeatureId}; // DB ID
      const res = await fetch(`api/v1/map-features/${mapFeature.appId}`, {
        method: 'DELETE', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
      });
      
      //unloadGeofenceHandler();
      //   //if(res.ok) mapFeatures = mapFeatures.filter(feature => feature._id != mapFeature._id);
      await reloadMapFeatures();
      loadGeofenceHandler();
    } else {
      // do nothing
    }
  }

  const flyToMapFeature = async(mapFeature) => {
      const centroid = await getCentroid(mapFeature.mapFeature.geometry.coordinates);

      if(!mapFeaturesLoadedOnMap) loadGeofenceHandler();

      hidePanel(); 
      flyTo(centroid[0], centroid[1]);
  }

  const findMapFeature = async (appId, keywords) => { 
    //const appId = viewMode.getAppId().data._id;
    const res = await fetch(`api/v1/map-features/${appId}?keywords=${keywords}`);
    const json = await res.json();
    if(res.ok) {
        return json;
    } else {
        return [];
    }
  }
  //$: { findMapFeature(app._id, keywords);}
  $: {reloadMapFeatures(); keywords}

  const saveMapFeature = async (appId, body) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await fetch(`api/v1/map-features/${appId}`, {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify(body)
        });

         // Fetch list from db, incl the new map feature
        await reloadMapFeatures();
        // Reload polygons with updated labels
        unloadGeofenceHandler();
        loadGeofenceHandler();
        resolve(res);
    } catch (error) {
        reject(error);
    } 

    });
  }

  // 2023

  function TEST_GEOFENCE() {
    if(viewMode.getAppId().data._id == '6271803e707910639e5fdaf6') return true;
  }


  let mapFeatures = getMapFeatures();
  let mapFeaturesLoadedOnMap = false;
  
  async function getMapFeatures() {
    return await findMapFeature(viewMode.getAppId().data._id, keywords)
  }

  async function reloadMapFeatures() {
    mapFeatures = await getMapFeatures();
  }
  

async function getCentroid(geojson) {
    const res = await fetch('api/v1/map-features/geo/centroid', {
        method: 'POST', 
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({geojson})
        });
    const json = await res.json();
    const centroid = json.geometry.coordinates;
    return centroid;
}

function randomHexColor() {
  return '#'+(Math.random() * 0xFFFFFF << 0).toString(16).padStart(6, '0');
}

async function loadGeoJson() {

  // Hold the centroids and labels source
  let points = [];
 
  for (const mapFeature of mapFeatures) {
    const centroid = await getCentroid(mapFeature.mapFeature.geometry.coordinates);

    points.push({
      'type': 'Feature',
      'geometry': {
      'type': 'Point',
      'coordinates': centroid
      },
      'properties': {
      'title': mapFeature.title
      }
    });


    // Add a data source containing GeoJSON data.
    map.addSource(`${mapFeature._id}`, {
    'type': 'geojson',
    'data': {
    'type': 'Feature',
    'geometry': {
    'type': 'Polygon',
    'coordinates': mapFeature.mapFeature.geometry.coordinates
    }
    }
    });
     
    // Add a new layer to visualize the polygon.
    map.addLayer({
      'id': `${mapFeature._id}`,
      'type': 'fill',
      'source': `${mapFeature._id}`, // reference the data source
      'layout': {},
      'paint': {
      'fill-color': `${mapFeature.bgColor}`,
      'fill-opacity': 0.6
      }
    });

} // end loop



  map.addSource('points', {
    'type': 'geojson',
    'data': {
    'type': 'FeatureCollection',
    'features': points
    }
  });
 
  // Add a symbol layer
  map.addLayer({
    'id': 'points',
    'type': 'symbol',
    'source': 'points',
    'layout': {
    // get the title name from the source's "title" property
    'text-field': ['get', 'title'],
    'text-font': [
    'Open Sans Semibold',
    'Arial Unicode MS Bold'
    ],
    'text-offset': [0, -1],
    'text-anchor': 'center',
    'text-letter-spacing': 0.3,
    'text-size': 14
    },
    paint: {
      "text-color": "#fff",
      "text-halo-color": "#5A5A5A",
      "text-halo-width": 1.4
    }
  });



  /// QUIT HERE YES TODO




   



}
  




  const dispatch = createEventDispatcher();
  const elementAction = (tag) => {
    dispatch('elementAction', {tag});
  }

  // make sure fn is called only when the relevant panel is displayed.
  // or check how svelte handles it
  
  const findUserProfile = async (appId, keywords) => { await userProfiles.getAll(appId, keywords); }
  $: { findUserProfile(app._id, keywords);}

  const findDevice = async (appId, keywords) => { await devices.getAll(appId, keywords); }
  $: { findDevice(app._id, keywords);}
  
  const clearSearch = async () => { 
    keywords = ''; 
    searchInput.value = '';
  }
  // end make sure (...)

  $: {
    if(searchInput) {
      if(selectedTab === 'gpstrackers') searchInput.placeholder = "Find";
      if(selectedTab === 'geofences') searchInput.placeholder = "Find";
      if(selectedTab === 'tags') searchInput.placeholder = "Find";
      if(selectedTab === 'settings') searchInput.placeholder = "";
    }
  }

  const enableUserTracking = async () => {
    if(!$appSettings?.displayName) return alert("Please enter a display name to share along with your geolocation data.");
    await appSettings.post(app._id, {userTracking: true}); 
  }

  const disableUserTracking = async () => {await appSettings.post(app._id, {userTracking: false}); }
  
  const displayNameHandler = async (displayName) => { await appSettings.post(app._id, {displayName: displayName}); }

  // Update userprofile marker positions on map...
  let userProfileIntervalId;
  $: { if($appSettings && $appSettings?.liveMap === true) {
    clearInterval(userProfileIntervalId);
    userProfileIntervalId = setInterval(async () => {
      await userProfiles.getAll(app._id, '');
      $userProfiles.forEach(userProfile => {
        let marker = loadedUserProfileMarkers.filter(marker => marker.userProfile._id == userProfile._id)[0];
        // If there is a marker loaded for user profile in iteration, update position
        if(marker) {
          // Move marker to new location
          const longitude = userProfile.geolocation.longitude;
          const latitude = userProfile.geolocation.latitude;
          marker.setLngLat({lng: longitude, lat: latitude});
          if(loadedUserProfileMarkers.length + loadedDeviceMarkers.length === 1) flyTo(longitude, latitude);
          // Update popup content
          const popup = marker.getPopup();
          const domContent = getDefaultUserProfileMarkerContent(userProfile);
          popup.setDOMContent(domContent); 
        };
      })
    }, 5000);
    } else {
      clearInterval(userProfileIntervalId);
    }
  }

  

  // Save user's geolocation data
  let userTrackingInterval;
  $: {
    if($appSettings?.userTracking === true) {
      clearInterval(userTrackingInterval);
      userTrackingInterval = setInterval(() => {
        if ("geolocation" in navigator) { 
          navigator.geolocation.getCurrentPosition(async (geolocation) => { 
            let timestamp = geolocation.timestamp;
            let accuracy = geolocation.coords.accuracy;
            let altitude = geolocation.coords.altitude;
            let altitudeAccuracy = geolocation.coords.altitudeAccuracy;
            let heading = geolocation.coords.heading;
            let latitude = geolocation.coords.latitude;
            let longitude = geolocation.coords.longitude; 
            let speed = geolocation.coords.speed; 
            geolocation = {timestamp, accuracy, altitude, altitudeAccuracy, heading, latitude, longitude, speed};
            await appSettings.post(app._id, {geolocation});
          }); 
      } else { console.log("Geolocation is not available") }
      }, 5000);
    } else {
      clearInterval(userTrackingInterval);
    }
  }

  const enableLiveMap = async () => {await appSettings.post(app._id, {liveMap: true}); }
  const disableLiveMap = async () => {await appSettings.post(app._id, {liveMap: false}); }
  const setMapStyle = async(style) => {
    await  appSettings.post(app._id, {mapStyle: style});
  }

  // Update device marker positions on map
  let intervalId;
  $: { if($appSettings && $appSettings?.liveMap === true) {
    clearInterval(intervalId);
    intervalId = setInterval(() => {
        loadedDeviceMarkers.forEach(async (marker) => {
          const position = await findPosition(marker.device);
          marker.setLngLat({lng: position.longitudeDeg, lat: position.latitudeDeg});
          if(loadedUserProfileMarkers.length + loadedDeviceMarkers.length === 1) flyTo(position.longitudeDeg, position.latitudeDeg);
          // Update popup content
          const popup = marker.getPopup();
          const domContent = getDefaultPopupDOMContent(marker.device, position);
          popup.setDOMContent(domContent);
          addDefaultPopupButtons(popup, marker.device, domContent);
        })
    }, 5000);
    } else {
      clearInterval(intervalId);
    }
  }
  
  function viewLog (device) {
    modal.content.tag = 'log';
    modal.content.device = device;
    modal.show = true;
  }

  function hidePopup (popup) {
    popup.remove();
  }
  const togglePanel = () => { 
    showPanel = !showPanel; 
  }

  const findPosition = async (device) => {
    return await gpsPosition.getLatestOne(device.appId, device.deviceEui);
  }

  const deviceClickHandler = async (device) => {
    hidePanel(); 
    removeMarkers(); 
    const position = await findPosition(device); 
    await addDeviceMarker(device, position); 
    flyTo(position.longitudeDeg, position.latitudeDeg);
  }

  const userProfileClickHandler = async (userProfile) => {
    hidePanel(); 
    removeUserProfileMarkers(); 
    addUserProfileMarker(userProfile); 
    flyTo(userProfile.geolocation.longitude, userProfile.geolocation.latitude);
  }

  const userProfileTagClickHandler = async (filter) => {

    removeUserProfileMarkers(); 
    // We dont currently have db tags on userprofiles so we pass an empty filter..
    await userProfiles.getAll(app._id, ""); 

    $userProfiles.forEach(async (userProfile, index) => {
      addUserProfileMarker(userProfile);
      if(index === $userProfiles.length - 1) fitBounds(loadedUserProfileMarkers);
    });
  } 

  const getDefaultUserProfileMarkerContent = (userProfile) => {
    const dateOptions = {month: 'long', day: 'numeric', hour: "numeric", minute: "numeric"};
    const div = document.createElement('div');
    div.innerHTML += `<strong>${userProfile.displayName} (${(new Date(userProfile.geolocation.timestamp)).toLocaleString("no-NO", dateOptions)})</strong>`;
    return div;
  }
  
  const addUserProfileMarker = (userProfile) => {
    const domContent = getDefaultUserProfileMarkerContent(userProfile);

    const popup = new mapboxgl.Popup({closeButton: false, closeOnClick: false})
    .setDOMContent(domContent)
    .addTo(map);

    const marker = new mapboxgl.Marker({ color: '#FFDD57', rotation: 0 })
    .setLngLat([userProfile.geolocation.longitude, userProfile.geolocation.latitude])
    .setPopup(popup)
    .addTo(map)
    .togglePopup();

    marker.userProfile = userProfile; 
  
    loadedUserProfileMarkers = [marker, ...loadedUserProfileMarkers];

  }

  const deviceTagClickHandler = async (filter) => {

    //clearSearch();
    removeMarkers(); 
    await devices.getAll(app._id, filter, "tags");
    
    $devices.forEach(async (device, index) => {
      const position = await findPosition(device);
      await addDeviceMarker(device, position);
      if(index === $devices.length - 1) {
        fitBounds(loadedDeviceMarkers);
      }
    });

  }

  const fitBounds = (markers) => {
      const lng = markers.map(item => Number(item._lngLat.lng))
      const lat = markers.map(item => Number(item._lngLat.lat))
      const swLat = Math.max(...lat);
      const swLng = Math.min(...lng);
      const neLng = Math.max(...lng);
      const neLat = Math.min(...lat);

      map.fitBounds([
        [swLng, swLat], // southwestern corner of the bounds
        [neLng, neLat] // northeastern corner of the bounds
        ], {padding: 100, maxZoom: 18});
  }

  const getDefaultPopupDOMContent = (device, position) => {
    const div = document.createElement('div');
    div.innerHTML = `<p>${(new Date(position.receivedAt)).toLocaleString("no-NO", dateOptions)}</p>`
    div.innerHTML += `<p><strong>${device.title}</strong></p>`;
    div.innerHTML += `<p>Geofence: ${device?.meta?.geofenceTitle || 'No match'}</p>`;
    div.innerHTML += `<p>Tags: ${device.tags.join(", ")}</p>`;
    div.innerHTML += `
      <p style="font-size: 12px">
        Speed: ${position.speedKmph} kmph<br>
        Heading: ${position.headingDeg}<br>
        Battery: ${position.batV}<br>
        In Trip: ${position.inTrip}<br>
        Eui: ${device.deviceEui}<br>
        Received At: ${(new Date(position.receivedAt)).toLocaleString("no-NO", dateOptions)}
      </p>`;
    div.style.cssText = "font-size: 16px;";
    return div;
  }

  const addDefaultPopupButtons = (popup, device, domContent) => {
    
    const viewLogLink = document.createElement('a');
    viewLogLink.style.cssText = 'margin-right: 20px;';
    viewLogLink.textContent = 'View log';
    domContent.appendChild(viewLogLink)
    viewLogLink.addEventListener('click', () => { viewLog(device) })

    const viewHideLink = document.createElement('a');
    viewHideLink.style.cssText = 'margin-right: 20px';
    viewHideLink.textContent = 'Close';
    domContent.appendChild(viewHideLink)
    viewHideLink.addEventListener('click', () => { hidePopup(popup) })
  }

  const addDeviceMarker = async (device, position) => { 
    
    const domContent = getDefaultPopupDOMContent(device, position);
    const popup = new mapboxgl.Popup({closeButton: false, closeOnClick: false })
    .setDOMContent(domContent)
    .addTo(map);

    addDefaultPopupButtons(popup, device, domContent);

    const marker = new mapboxgl.Marker({ color: '#FF3860', rotation: 0 })
    .setLngLat([position.longitudeDeg, position.latitudeDeg])
    .setPopup(popup)
    .addTo(map);

    marker.device = device; 
  
    loadedDeviceMarkers = [marker, ...loadedDeviceMarkers];
  }


  const flyTo = (lng, lat) => {
    map.flyTo({
      center: [
       lng,
        lat
      ],
      zoom: 18,
      speed: 4,
      essential: true // this animation is considered essential with respect to prefers-reduced-motion..
      });
  }

  let defaultLocation = {};

  const saveDefaultLocation = async () => {
    await appSettings.post(app._id, {defaultLocation: defaultLocation});
    defaultLocation = {};
    removeMarkers();
  } 
  const cancelSetDefaultLocation = () => {
    defaultLocation = {};
    removeMarkers();
  } 

  const setDefaultLocation = () => {
    const showPos = (pos) => { 
      
        const marker = new mapboxgl.Marker({
        color: '#48C78E',
        draggable: true
        })
        .setLngLat([pos.coords.longitude , pos.coords.latitude ])
        .addTo(map);

        loadedDeviceMarkers = [...loadedDeviceMarkers, marker];

        flyTo(pos.coords.longitude,
        pos.coords.latitude)

        defaultLocation = marker.getLngLat();

        function onDragEnd() {
          defaultLocation = marker.getLngLat();
        }

        marker.on('dragend', onDragEnd);
    }
    navigator.geolocation.getCurrentPosition(showPos);
  }

  const removeMarkers = () => {
    loadedDeviceMarkers.forEach(marker => {
      marker.remove();
    });
    loadedDeviceMarkers = [];
  }

  const removeUserProfileMarkers = () => {
    loadedUserProfileMarkers.forEach(marker => {
      marker.remove();
    });
    loadedUserProfileMarkers = [];
  }

  const positionLogEvent = async (e) => {
    if(e.detail.tag === 'view-on-map')  {
      modal.show = false;
      const {position, device} = e.detail;
      removeMarkers();
      await addDeviceMarker(device, position)
      flyTo(position.longitudeDeg, position.latitudeDeg);
    }
    
  }


  onMount(async () => {

    // Load User Profile - todo Move to top level component
    await appSettings.get(app._id);

    map = new mapboxgl.Map({
    container: "map",
    style: $appSettings?.mapStyle ? $appSettings.mapStyle : mapStyleStreet,
    center: [16.37, 48.2],
    zoom: 12,
  });

  const geoLocate = new mapboxgl.GeolocateControl({
    positionOptions: {
    enableHighAccuracy: true
    },
    // When active the map will receive updates to the device's location as it changes.
    trackUserLocation: true,
    // Draw an arrow next to the location dot to indicate which direction the device is heading.
    showUserHeading: true
    })

  map.addControl(geoLocate);

  geoLocate.on("trackuserlocationstart", () => {
    hidePanel();
  });

  geoLocate.on("trackuserlocationend", () => {
    hidePanel();
  });

// Fly to location set in user profile
if($appSettings?.defaultLocation) 
flyTo($appSettings.defaultLocation.lng, $appSettings.defaultLocation.lat);
  
  });

  // MOVE TO HELPERS
  const hidePanel = () => {
    if(getBrowserWidth() < 900) showPanel = false;
  }

  function getBrowserWidth() {
  return Math.max(
    document.body.scrollWidth,
    document.documentElement.scrollWidth,
    document.body.offsetWidth,
    document.documentElement.offsetWidth,
    document.documentElement.clientWidth
  );
  // MOVE TO HELPERS... 
}


const draw = new MapboxDraw({
displayControlsDefault: false,
// Select which mapbox-gl-draw control buttons to add to the map.
controls: {
polygon: true,
trash: true
},
// Set mapbox-gl-draw to draw by default.
// The user does not have to click the polygon control button first.
defaultMode: 'draw_polygon'
});



const loadGeofenceHandler = () => {

  loadGeoJson();
  mapFeaturesLoadedOnMap = true;
}

const unloadGeofenceHandler = () => {
  // unload and set bool to false
  for (const mapFeature of mapFeatures) {
    if(map.getLayer(mapFeature._id)) {
      map.removeLayer(mapFeature._id);
      map.removeSource(mapFeature._id);
    }
  }

  // Remove Geofence Labels
  if(map.getLayer('points')) {
    map.removeLayer('points');
    map.removeSource('points');
  }
  mapFeaturesLoadedOnMap = false;
}

const addDrawControlHandler = () => {
  map.addControl(draw);
  map.on('draw.create', updateArea);
  map.on('draw.delete', updateArea);
  map.on('draw.update', updateArea);
  drawControlEnabled = true;

}

const removeDrawControlHandler = () => {
  map.removeControl(draw);
  drawControlEnabled = false;
}

async function updateArea(e) {
    const data = draw.getAll();
    if (data.features.length > 0) {
  
    const appId = viewMode.getAppId().data._id;

    for (let index = 0; index < data.features.length; index++) {
      const mapFeature = data.features[index];
      const mapFeatureId = mapFeature.id;
      
      const alreadyExists = mapFeatures.filter(feature => feature.mapFeatureId == mapFeature.id);
      let bgColor =  randomHexColor();
      if(alreadyExists.length === 1) bgColor = alreadyExists[0].bgColor
      
      const body = {
        mapFeatureId,
        bgColor,
        mapFeature
      }
      await saveMapFeature(appId, body);
      await reloadMapFeatures();
    }
  } else {
    if (e.type !== 'draw.delete')
    alert('Click the map to draw a polygon.');
  }

  //map.removeControl(draw);
}


</script>

<Login/>

<div class="content">
  <div id="map"></div> 
  <button on:click={(e) => { elementAction("apps"); }} on:keydown={() => {}} class="is-light home-button button is-large"><span class="icon is-size-4"><i class="fas fa-bars"></i></span></button>  
  <button on:click={togglePanel} on:keydown={() => {}} class="is-danger toggle-panel-button button is-large"><span class="icon is-size-4"><i class="fas fa-magnifying-glass"></i></span></button>
  {#if showPanel}
    <nav class="panel m-2">
      <div class="panel-block">
        <p class="control has-icons-left">
          <!-- <input class="input" type="text" bind:this={searchInput} bind:value={keywords} placeholder="Find Tracker" disabled={selectedTab === 'settings'}> TBD -->  
          <input class="input" type="search" bind:this={searchInput} on:change={(e) => {keywords = e.target.value}} placeholder="Find Tracker" disabled={selectedTab === 'settings'}>
          <span class="icon is-left">
            <i class="fas fa-search" aria-hidden="true"></i>
          </span>
        </p>
      </div>
      <p class="panel-tabs">
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class:is-active={selectedTab === 'gpstrackers'} on:click={() => {selectedTab = 'gpstrackers'}} on:keydown={() => {}}>Tracker</a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class:is-active={selectedTab === 'tags'} on:click={() => {selectedTab = 'tags'}} on:keydown={() => {}}>Tag</a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class:is-active={selectedTab === 'geofences'} on:click={() => {selectedTab = 'geofences'}} on:keydown={() => {}}>Geofence</a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class:is-active={selectedTab === 'users'} on:click={() => {selectedTab = 'users'}} on:keydown={() => {}}>User</a>

        <!-- svelte-ignore a11y-missing-attribute -->
        <a class:is-active={selectedTab === 'settings'} on:click={() => {selectedTab = 'settings'}} on:keydown={() => {}}><i class="fa-solid fa-gear" aria-hidden="true"></i></a>
      </p>

      {#if selectedTab === 'gpstrackers'}
        {#await devices.getAll(app._id, keywords)} 
          <!-- <p>Fetching devices</p> -->
          <div class="panel-block">
            <button class="button is-loading is-small is-fullwidth">Loading</button>
          </div>
          {:then}
            {#each $devices as device }
              <!-- svelte-ignore a11y-missing-attribute -->
              <a class="panel-block is-active" on:click={() => deviceClickHandler(device)} on:keydown={() => {}}>
                <span class="panel-icon has-text-danger">
                  <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
                </span>
                  {device.title}
              </a>
              {#if device.tags.length > 0}
                <div class="panel-block">
                  <div class="tags">
                    {#if device?.meta?.geofenceTitle}
                      <span class="tag is-info is-light">{device.meta.geofenceTitle}</span>
                    {/if}
                    {#each device.tags as tag}
                      {#if tag.length > 0}
                        <span class="tag is-light is-clickable" on:click={ () => deviceTagClickHandler(tag)} on:keydown={() => {}}>{tag}</span>
                      {:else}
                        <span class="tag">&nbsp;</span>
                      {/if}
                    {/each}
                    {#if device.tags.length === 0}
                      <span class="tag">&nbsp;</span>
                    {/if}
                  </div>
                </div>
              {/if}
            {/each}
          {:catch error}
            <p>{error}</p>
       {/await}
      {/if}

      {#if selectedTab === 'tags'}
      {#await devices.getTags(app._id, keywords)} 
        <!-- <p>Fetching tags</p> -->
        <div class="panel-block">
          <button class="button is-loading is-small is-fullwidth">Loading</button>
        </div>
        {:then tags}
        <div class="panel-block is-active">
          <div class="tags are-medium">
            {#each tags as tag }
              <div class="tags has-addons m-1 is-clickable" on:click={async () => {hidePanel(); await deviceTagClickHandler(tag._id)}} on:keydown={() => {}}>
                <span class="tag">{tag._id}</span>
                <span class="tag count-tag">{tag.count}</span>
              </div>
            {/each}
          </div>
        </div>
        {:catch error}
          <p>{error}</p>
      {/await}
      {/if}

      {#if selectedTab === 'geofences'}

        {#if TEST_GEOFENCE()}

         <!-- svelte-ignore a11y-missing-attribute -->
         <a class="panel-block is-active" on:click={mapFeaturesLoadedOnMap ? unloadGeofenceHandler : loadGeofenceHandler} on:keydown={() => {}}>
          <span class="panel-icon has-text-success">
            <i class="fas fa-info-circle" aria-hidden="true"></i>
          </span>
          {#if mapFeaturesLoadedOnMap}
            <a class="panel-block is-active">Hide geofences</a>
          {:else}
            <a class="panel-block is-active">Show geofences</a>
          {/if}
        </a>
        <!-- svelte-ignore a11y-missing-attribute -->
        <a class="panel-block is-active" on:click={drawControlEnabled ? removeDrawControlHandler : addDrawControlHandler} on:keydown={() => {}}>
        <span class="panel-icon has-text-success">
          <i class="fas fa-info-circle" aria-hidden="true"></i>
        </span>
        {#if drawControlEnabled}
          <a class="panel-block is-active">Disable draw tool</a>
        {:else}
        <a class="panel-block is-active">Enable draw tool</a>
        {/if}
        </a>  


        {#await mapFeatures} 
        <!-- <p>Fetching devices</p> -->
        <div class="panel-block">
          <button class="button is-loading is-small is-fullwidth">Loading</button>
        </div>
        {:then mapFeatures}
          {#each mapFeatures as feature }
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="panel-block is-active">
              {#if viewMode.getAppId().data.isAdmin}
                <span class="mr-2 icon is-size-7 has-text-danger" on:click={() => deleteMapFeatureHandler(feature)} on:keydown={() => {}}><i class="fas fa-trash"></i></span>
              {/if}
              {#if viewMode.getAppId().data.isAdmin}
                <input class="input" type="text" placeholder="Text input" value="{feature.title}" on:change={
                  async(event) => {
                    feature.title = event.target.value;
                    await saveMapFeature(feature.appId, feature);
                    await reloadMapFeatures();
                  }
                }>
              {:else}
               {feature.title}
              {/if}
              <span class="ml-2 tag is-info is-light" on:click={() => flyToMapFeature(feature)} on:keydown={() => {}}>Fly to</span>
            </a>
          {/each}
        {:catch error}
          <p>{error}</p>
        {/await}
        
        {/if}  <!-- {/if} {TEST_GEOFENCE} -->

      {/if}


      {#if selectedTab === 'users'}
      {#await userProfiles.getAll(app._id, keywords)} 
        <!-- <p>Fetching user profiles</p> -->
        <div class="panel-block">
          <button class="button is-loading is-small is-fullwidth">Loading</button>
        </div>
        {:then}
          {#each $userProfiles as userProfile }
            <!-- svelte-ignore a11y-missing-attribute -->
            <a class="panel-block is-active" on:click={async () => await userProfileClickHandler(userProfile)} on:keydown={() => {}}>
              <span class="panel-icon has-text-warning">
                <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
              </span>
              {userProfile.displayName}
            </a>
            <div class="panel-block">
              <div class="tags">
                  <span class="tag is-light" on:click={userProfileTagClickHandler} on:keydown={() => {}}>users</span>
              </div>
            </div>
          {/each}
        {:catch error}
          <p>{error}</p>
     {/await}
    {/if}
      {#if selectedTab === 'settings'}
        <!-- svelte-ignore a11y-missing-attribute -->
        <div class="panel-block is-active">
          <p class="has-text-grey is-size-7">Map Style</p>
        </div>
        <div class="panel-block is-active">
          <div class="control">
            <label class="radio">
              <input type="radio" name="map-style" value={mapStyleStreet} checked={$appSettings?.mapStyle === mapStyleStreet} on:click={() => map.setStyle(mapStyleStreet)} on:click={e => setMapStyle(e.target.value)} on:keydown={() => {}}>
              Street
            </label>
            <label class="radio">
              <input type="radio" name="map-style" value={mapStyleSatelite} checked={$appSettings?.mapStyle === mapStyleSatelite} on:click={() => map.setStyle(mapStyleSatelite)} on:click={() => map.setStyle(mapStyleSatelite)} on:click={e => setMapStyle(e.target.value)} on:keydown={() => {}}>
              Satelite
            </label>
            <label class="radio">
              <input type="radio" name="map-style" value={mapStyleDark} checked={$appSettings?.mapStyle === mapStyleDark} on:click={() => map.setStyle(mapStyleDark)} on:click={() => map.setStyle(mapStyleDark)} on:click={e => setMapStyle(e.target.value)} on:keydown={() => {}}>
              Dark
            </label>
          </div>
        </div>
        <div class="panel-block is-active">
          <p class="has-text-grey is-size-7">Fly To Position at Map Load</p>
        </div>
        <div class="panel-block is-active">
          <!-- svelte-ignore a11y-missing-attribute -->
          <a class="mr-4 " on:click={setDefaultLocation} on:keydown={() => {}}>Set default location</a>
          <button class="mr-1 button is-small is-info" class:is-hidden={Object.keys(defaultLocation).length === 0} on:click={saveDefaultLocation} on:keydown={() => {}}>Save</button>
          <button class="button is-small is-light" class:is-hidden={Object.keys(defaultLocation).length === 0} on:click={cancelSetDefaultLocation} on:keydown={() => {}}>Cancel</button>
        </div>
        {#if $appSettings?.defaultLocation}
        <div class="panel-block is-active">
          <!-- svelte-ignore a11y-missing-attribute -->
          <a on:click={() => flyTo($appSettings.defaultLocation.lng, $appSettings.defaultLocation.lat)} on:keydown={() => {}}>Fly to set location</a>
        </div>
        {/if}
        <div class="panel-block is-active">
          <p class="has-text-grey is-size-7">Live Map Reload</p>
        </div>
        <div class="panel-block is-active">
          <div class="buttons has-addons">
            <button class="button is-small" class:is-info={$appSettings?.liveMap} on:click={enableLiveMap} on:keydown={() => {}}>Enabled</button>
            <button class="button is-small" class:is-info={!$appSettings?.liveMap} on:click={disableLiveMap} on:keydown={() => {}}>Disabled</button>
            <button class="button is-loading is-small ml-2" class:is-hidden={!$appSettings?.liveMap}></button>
          </div>
        </div>
        <div class="panel-block is-active">
          <p class="has-text-grey is-size-7">Share Position</p>
        </div>
        
        <div class="">
          <div class="control displayname">
            <input class="input" type="text" placeholder="Display Name (required)" value={$appSettings?.displayName} on:change={e => displayNameHandler(e.target.value)}>
          </div>
        </div>

        <div class="panel-block is-active">
          <div class="buttons has-addons">
            <button class="button is-small" class:is-info={$appSettings?.userTracking} on:click={enableUserTracking}>Enabled</button>
            <button class="button is-small" class:is-info={!$appSettings?.userTracking} on:click={disableUserTracking}>Disabled</button>
            <button class="button is-loading is-small ml-2" class:is-hidden={!$appSettings?.userTracking}></button>
          </div>
        </div>
        <div class="panel-block is-active">
          <p class="is-size-7">Enabling this option let other users view data from your device and allows the application to store the following:
            longitude, latitude, speed, heading, elevation, timestamp and accuracy.</p>
        </div>
        <div class="panel-block is-active">&NonBreakingSpace;</div>
      {/if}
      {#if selectedTab !== 'settings'}
        <div class="panel-block">
          <button class="button is-info is-outlined is-fullwidth" on:click={async () => {clearSearch(), findDevice(app._id, keywords); findUserProfile(app._id, keywords);}} on:click={e => e.target.blur()}>
            Reset all filters
          </button>
        </div>
      {/if}
    </nav>
  {/if}


  {#if modal.content.tag === 'log'}
    <Modal show={modal.show} on:elementAction={modalEvents}>
      <span slot="title">{modal.content.device.title}</span>
      <div slot="content"><PositionLog device={modal.content.device} on:elementAction={positionLogEvent}/></div>
    </Modal>
  {/if}

</div>
 
  
<style>
    .content {
      position: relative;
    }
    .count-tag {
      background-color:  rgb(238, 238, 238);
    }
    .is-clickable:hover {
      cursor: pointer;
    }
    .panel {
      position: absolute;
      z-index: 3;
      background-color: rgba(255, 255, 255, .96);
    }
    
    #map {
      position: absolute;
      z-index: 1;
      width: 100vw;
      height: 100vh;
    }
    .toggle-panel-button {
        z-index: 2;
        position: absolute;
        top: 190px;
        right: 0px;
        border-radius: 4px 0 0 4px; 
    }
    .home-button {
      z-index: 2;
      position: absolute;
      top: 120px;
      right: 0px;
      border-radius: 4px 0 0 4px; 
    }
    .panel {
      max-width: 320px;
      overflow-y: auto;
      max-height: calc(100vh - 100px);
    }
    .displayname {
      max-width: 320;
      margin: 10px;
    }

  
    
</style>